function getSignedUploadUrl(contentType, fileName) {
  return fetch(
    '/file-upload-get-signed-url-cloudflare?' +
      new URLSearchParams({
        file_type: contentType,
        file_name: fileName,
      }),
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  ).then((response) => {
    return response.json();
  });
}

window.updateThumbnail = async function (target, file) {
  try {
    let processedFile = file;
    let name = file.name;
    let type = file.type;

    if (shouldEncodeToWebP(file)) {
      processedFile = await encodeToWebP(file);
      name = processedFile.name;
      type = processedFile.type;
    } else if (shouldEncodeToWebM(file)) {
      processedFile = await encodeToWebM(file);
      name = processedFile.name;
      type = processedFile.type;
    }

    name = removeSpecialUrlChars(name);

    const signedUrl = await getSignedURLAndUpload(processedFile, type, name);

    var $currentTarget = $(target);
    const bucket = signedUrl.bucket_name || 'netwrckstatic.netwrck.com';
    const fullUrl = `https://${bucket}/${signedUrl.object_path}`;

    if ($currentTarget.hasClass('bannerdropzone')) {
      $currentTarget.find('.banner-preview').css('background-image', `url(${fullUrl})`);
      $currentTarget.find('.bannerurl').val(signedUrl.object_path);
    } else {
      $currentTarget
        .find('.new-ai-avatar-upload')
        .html(`<img src="${fullUrl}" width="81" height="81"/>`);
      $currentTarget.find('.newaiavatarurl').val(signedUrl.object_path);
      $currentTarget.find('.newaibucketname').val(bucket);
    }
  } catch (err) {
    console.log(err);
    alert('upload failed please try again - try with a different file name');
  }
};

function removeSpecialUrlChars(name) {
  return name.replace(/[,!#$%^&*(){}[\]<>;'?=":]/g, '').replace(/\s+/g, '-');
}

function getSignedURLAndUpload(file, type, name) {
  let signedUploadUrlPromise = getSignedUploadUrl(type, name);

  function uploadToSignedUrlPromise(signedUrl) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', signedUrl.url, true);
      xhr.onload = () => {
        const status = xhr.status;
        if (status === 200) {
          resolve(signedUrl);
        } else {
          reject('Something went wrong!');
        }
      };

      xhr.onerror = () => {
        reject('Something went wrong');
      };
      xhr.setRequestHeader('Content-Type', type);

      xhr.send(file);
    });
  }

  return signedUploadUrlPromise.then(uploadToSignedUrlPromise);
}

if (typeof fileExtensionToMimeType === 'undefined') {
  window.fileExtensionToMimeType = {
    jpg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    gif: 'image/gif',
    svg: 'image/svg+xml',
    bmp: 'image/bmp',
    tiff: 'image/tiff',
    ico: 'image/x-icon',
    wbmp: 'image/vnd.wap.wbmp',
    xbm: 'image/x-xbitmap',
    ppm: 'image/x-portable-pixmap',
    pgm: 'image/x-portable-graymap',
    pbm: 'image/x-portable-bitmap',
    mp4: 'video/mp4',
    webm: 'video/webm',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
  };
  var fileExtensionToMimeType = window.fileExtensionToMimeType;
} else {
  var fileExtensionToMimeType = window.fileExtensionToMimeType;
}

window.fileExtensionToMimeType = fileExtensionToMimeType;

function shouldEncodeToWebP(file) {
  return (
    file.type.startsWith('image/') &&
    !file.type.includes('svg') &&
    !file.type.includes('gif') &&
    file.type !== 'image/webp'
  );
}

function shouldEncodeToWebM(file) {
  return file.type.startsWith('video/') && file.type !== 'video/webm';
}

async function encodeToWebP(file) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();

    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);

      canvas.toBlob(
        (blob) => {
          if (blob) {
            const newFile = new File(
              [blob],
              file.name.replace(/\.[^.]+$/, '.webp'),
              {
                type: 'image/webp',
              }
            );
            resolve(newFile);
          } else {
            reject(new Error('Failed to encode to WebP'));
          }
        },
        'image/webp',
        0.85
      );
    };

    img.onerror = () => reject(new Error('Failed to load image'));
    img.src = URL.createObjectURL(file);
  });
}

async function encodeToWebM(file) {
  console.log('Video encoding to WebM not yet implemented, uploading original');
  return file;
}

async function createFile(url) {
  if (!url || typeof url !== 'string') throw new Error('createFile: missing url');
  let response = await fetch(url);
  let data = await response.blob();
  let fileName = (url.split('?')[0].split('/').pop()) || 'upload';
  let fileExtension = fileName.split('.').pop();
  let metadata = {
    type: fileExtensionToMimeType[fileExtension],
  };
  let file = new File([data], fileName, metadata);
  return file;
}

function getOpenNewAIForm() {
  const form = document.getElementById('add-new-ai-form');
  if (!form) return null;
  const dialog = form.closest('dialog');
  if (dialog && !dialog.open) return null;
  if (!dialog) {
    const style = window.getComputedStyle(form);
    if (style.display === 'none' || style.visibility === 'hidden') return null;
  }
  return form;
}

function getPastedImageFile(event) {
  const clipboardData = event.clipboardData || window.clipboardData;
  const items = clipboardData && clipboardData.items;
  if (!items) return null;
  for (let i = 0; i < items.length; i++) {
    if (
      items[i].kind === 'file' &&
      items[i].type &&
      items[i].type.indexOf('image/') === 0
    ) {
      const file = items[i].getAsFile();
      if (!file) continue;
      if (file.name) return file;
      const ext = (file.type.split('/')[1] || 'png').replace(/[^a-z0-9]/gi, '');
      return new File([file], 'pasted-image-' + Date.now() + '.' + ext, {
        type: file.type,
      });
    }
  }
  return null;
}

function bindCreateAIPasteUpload() {
  if (window.__createAIPasteUploadBound) return;
  window.__createAIPasteUploadBound = true;
  document.addEventListener(
    'paste',
    function (event) {
      const form = getOpenNewAIForm();
      if (!form) return;
      const file = getPastedImageFile(event);
      if (!file) return;
      const dropZoneElement =
        form.querySelector('.newaidropzone') || form.querySelector('.drop-zone');
      if (!dropZoneElement) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      updateThumbnail(dropZoneElement, file);
    },
    true
  );
}

function bindCreateAIGeneratedImageUpload() {
  if (window.__createAIGeneratedImageUploadBound) return;
  window.__createAIGeneratedImageUploadBound = true;
  document.addEventListener(
    'click',
    async function (event) {
      const chooser =
        event.target &&
        event.target.closest &&
        event.target.closest('.ai-generated-char-chooser');
      if (!chooser) return;
      const form = getOpenNewAIForm();
      if (!form) return;
      const artDialog = document.getElementById('create-pic-dialog');
      if (!artDialog || !artDialog.open) return;
      const dropZoneElement =
        form.querySelector('.newaidropzone') || form.querySelector('.drop-zone');
      if (!dropZoneElement) return;
      const imageURL = chooser.getAttribute('src');
      if (!imageURL) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      try {
        await updateThumbnail(dropZoneElement, await createFile(imageURL));
        artDialog.close();
      } catch (err) {
        console.error('Avatar image selection failed:', err);
        alert('upload failed please try again - try with a different image');
      }
    },
    true
  );
}

$(document).ready(function () {
  bindCreateAIPasteUpload();
  bindCreateAIGeneratedImageUpload();
  document.querySelectorAll('.drop-zone__input').forEach((inputElement) => {
    const dropZoneElement = inputElement.closest('.drop-zone');

    dropZoneElement.addEventListener('click', (e) => {
      $(inputElement).click();
    });
    $(inputElement).on('click', function stopProp(e) {
      e.stopPropagation();
    });

    inputElement.addEventListener('change', (e) => {
      if (inputElement.files.length) {
        updateThumbnail(dropZoneElement, inputElement.files[0]);
      }
    });

    dropZoneElement.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropZoneElement.classList.add('drop-zone--over');
    });

    ['dragleave', 'dragend'].forEach((type) => {
      dropZoneElement.addEventListener(type, (e) => {
        dropZoneElement.classList.remove('drop-zone--over');
      });
    });

    dropZoneElement.addEventListener('drop', async (e) => {
      e.preventDefault();

      if (e.dataTransfer.files.length) {
        inputElement.files = e.dataTransfer.files;
        updateThumbnail(dropZoneElement, e.dataTransfer.files[0]);
      } else {
      }

      dropZoneElement.classList.remove('drop-zone--over');
    });

    window.setDropzoneImgToUrl = async function (url) {
      if (!url) return;
      try {
        updateThumbnail(dropZoneElement, await createFile(url));
      } catch (err) {
        console.error('setDropzoneImgToUrl failed:', err);
      }
    };
  });
});
